// @flow
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const Related = styled.div`
  margin-top: 24px;
  margin-bottom: ${({ hide }) => (hide ? '30px' : '0')};

  ${({ hide }) => {
    if (hide) {
      return maxMediaQueries[hide]`display: none;`;
    }
    return null;
  }};
`;
